import { ImageUploaderState } from "../types";

export const reset = (state: ImageUploaderState) => {
    state.images = [];
    state.uploadType = "device";
};
